import type AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import SectionFactory from '@/modules/common/common/models/APP/InsuranceSectionsFactory'
import CommonMapper from '@/modules/core/mappers/CommonMapper'
import AdditionalCoverageConfig from '@/modules/health/hiring/models/APP/AdditionalCoverageConfig'

function _convertSections(
  acc: AbstractAccordion<any>[],
  [key, items]: [string, any[]]
): AbstractAccordion<any>[] {
  if (key === ':type') return acc

  const elements = _getAccordionElements(key, items)
  return [...acc, ...elements]
}
function _getAccordionElements(key: string, items: any[]): AbstractAccordion<any>[] {
  return (
    items?.reduce((acc, attrs: any) => {
      const element = SectionFactory.createAccordion(key, attrs)
      if (!element) return acc

      return [...acc, element]
    }, []) ?? []
  )
}

export default class AdditionalCoveragesConfig {
  static getCoverages(data: any): AdditionalCoverageConfig {
    if (!data) return new AdditionalCoverageConfig({})
    const highlights = CommonMapper.fromDXPProductHighlights(data.highlights)
    const sectionEntries = Object.entries((data.sections as Record<string, any[]>) ?? {})
    const sections: AbstractAccordion<any>[] = sectionEntries.reduce(_convertSections, [])
    sections.sort((a, b) => Number(a.order) - Number(b.order))

    return new AdditionalCoverageConfig({
      code: data.coverageCode,
      number: data.coverageNumber,
      mandatory: data.mandatory,
      minAge: data.minAge,
      maxAge: data.maxAge,
      capitals: data.coverageInfoCapitals.map((i: any) => i.sumInsured),
      period: data.priceSuffix,
      label: data.coverageName,
      headerTitle: data.coveragePreTitle,
      icon: import.meta.env.VITE_API_URL_DXP_ROOT + data.coverageIcon,
      message: data.coverageDescription,
      highlights,
      sections
    })
  }
}
